/* eslint-disable no-console */
/* eslint-disable max-len */
import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Email/';

const sendEmail = async (model) => axiosInstance.post(`${ENDPOINTORIGIN}SendEmail`, model, constants.REQUIRE_INTERCEPTORS);

const sendPublicRecordRequestEmail = async (model) => axiosInstance.post(`${ENDPOINTORIGIN}SendPublicRecordRequestEmail`, model, constants.REQUIRE_INTERCEPTORS);

const sendEmailWithTemplate = () => console.log('New Feature');

export {
  sendEmail,
  sendPublicRecordRequestEmail,
  sendEmailWithTemplate,
};